import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Sort } from 'src/icons/Sort.icon';
import { Dropdown, Menu, Progress } from 'antd';
import {
  ActionMenuIcon,
  BinIcon,
  EditAppointmentIcon,
  PlusIcon,
} from 'src/icons';
import { SuperAdminTable } from '../../../baseComponents/Table';
import { Button } from '../../../baseComponents';
import {
  ehrFilterOrganizationAction,
  filterOrganizationApiAction,
  getAllActiveOrganizationAction,
  getAllOrganizationPaginationAction,
  getFronteggPlans,
  getOrganizationByIdAction,
} from 'src/modules/SuperAdmin/store/actions/organization.action';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Form, Formik } from 'formik';
import DeleteOrganization from './DeleteOrganization';
import { Bars } from 'react-loader-spinner';
import { getOrganizationByIdSlice } from 'src/modules/SuperAdmin/store/slices/organization.slice';
import { storeInLocal } from 'src/lib/storage';
import {
  getAllPractitionerListAction,
  getPractitionersOrgLevel,
} from 'src/modules/SuperAdmin/store/actions/practitioner.action';
import { getFromStorage } from '../../../../../../lib/storage';
import organizationEventEmitter from '../../../../../../utilities/organizationEmmiter';

const Organizationpage = ({
  setActiveButton,
  setIsPractitionerHomePage,
  setSelectedPractitionerOrganizationId,
  setSelectedPractitionerOrganizationName,
  setSelectedPractitionerOrganization,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/superadmin/addOrganization');
  };

  const {
    getAllOrganizationList,
    organizationTotal,
    filteredOrganizationTotal,
    organizationLoading,
    getActiveOrganizationsList,
  } = useSelector((state) => state?.organizationState);
  const { currentPractitioner } = useSelector(
    (state) => state?.practitionerState
  );
  const { isLoading } = useSelector((state) => state?.conditionState);
  const [_isShowLoading, setIsLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [isfilterOn, setIsFilterOn] = useState(false);
  const [_organizationDropdown, setOrganizationDropdown] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedOrganization, setSelectedOrganization] = useState(() => {
    const savedOrg = getFromStorage('superAdminSelectedOrganization');
    const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
    return parsedSavedOrg?.value || currentPractitioner?.org_id || null;
  });

  const [selectedOrganizationUUID, setSelectedOrganizationUUID] = useState(
    () => {
      const savedOrg = getFromStorage('superAdminSelectedOrganization');
      const parsedSavedOrg = savedOrg ? JSON.parse(savedOrg) : null;
      return (
        parsedSavedOrg?.org_uuid || currentPractitioner?.org_uuidid || null
      );
    }
  );

  const [selectedEHRSystem, _setSelectedEHRSystem] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const itemsPerPage = 25;
  const [startIndex, setStartIndex] = useState(25);
  const [_visibleItems, setVisibleItems] = useState([]);

  const [_organizationName, setOrganizationName] = useState(null);

  const handleShowMore = () => {
    setIsLoading(true);
    const endIndex = startIndex + itemsPerPage;
    setStartIndex(endIndex);
    setVisibleItems((prevItems) => [
      ...prevItems,
      ...filteredData.slice(startIndex, endIndex),
    ]);
  };

  useEffect(() => {
    if (filteredData) {
      const currentItems = filteredData.slice(0, startIndex + itemsPerPage);
      setVisibleItems(currentItems);
    }
  }, [filteredData, startIndex]);
  const denominator =
    filteredOrganizationTotal != null
      ? filteredOrganizationTotal
      : organizationTotal;
  const beforepercent = filteredData?.length / denominator;

  useEffect(() => {
    setIsLoading(organizationLoading);
  }, [organizationLoading]);

  useEffect(() => {
    // dispatch(getAllOrganizationAction());
    // dispatch(getAllOrganizationPaginationAction(startIndex, undefined));
    dispatch(getOrganizationByIdSlice(null));
    dispatch(getAllActiveOrganizationAction());
    dispatch(ehrFilterOrganizationAction());
    dispatch(getFronteggPlans());
  }, [dispatch, startIndex]);

  useEffect(() => {
    if (
      getAllOrganizationList &&
      Array.isArray(getAllOrganizationList) &&
      getAllOrganizationList.length > 0
    ) {
      let newData = getAllOrganizationList?.map((list, index) => {
        let website = list?.website;
        if (website && !/^https?:\/\//i.test(website)) {
          website = `http://${website}`;
        }
        return {
          key: index,
          org_name: list?.org_name
            ? capitalizeFirstLetter(list?.org_name)
            : 'N/A',
          website: (
            <a
              href={website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:text-[#00D090] focus:no-underline focus:text-black"
            >
              {list?.website}
            </a>
          ),
          org_id: list?.org_id,
          ehr_id: list?.ehr_id,
          logo_url: list?.logo_url,
          org_uuid: list?.org_uuid,
        };
      });
      if (newData && Array.isArray(newData) && newData.length > 0) {
        if (isfilterOn && selectedOrganization && !selectedEHRSystem) {
          newData = newData.filter(
            (item) => item.org_id === selectedOrganization
          );
        } else if (isfilterOn && selectedEHRSystem && !selectedOrganization) {
          newData = newData.filter((item) => item.ehr_id === selectedEHRSystem);
        } else if (isfilterOn && selectedEHRSystem && selectedOrganization) {
          newData = newData.filter(
            (item) =>
              item.ehr_id === selectedEHRSystem &&
              item.org_id === selectedOrganization
          );
        }
        setData(newData);
        setFilteredData(newData);
        setIsLoading(false);
      }
    } else {
      setFilteredData([]);
      setIsLoading(false);
    }
  }, [
    getAllOrganizationList,
    isfilterOn,
    selectedOrganization,
    selectedEHRSystem,
  ]);

  useEffect(() => {
    if (
      getActiveOrganizationsList &&
      Array.isArray(getActiveOrganizationsList)
    ) {
      let dataArr = [];
      getActiveOrganizationsList.forEach((key) => {
        // Filter out organizations with empty names as requested
        if (
          key?.org_id &&
          key?.org_name &&
          typeof key.org_name === 'string' &&
          key.org_name.trim() !== ''
        ) {
          dataArr.push({
            value: key?.org_id,
            label: key?.org_name,
            org_uuid: key?.org_uuid,
          });
        }
      });
      dataArr?.unshift({ label: 'All', value: 'All' });
      setOrganizationDropdown(dataArr);
    } else {
      // Reset dropdown if no valid organizations
      setOrganizationDropdown([{ label: 'All', value: 'All' }]);
    }
  }, [getActiveOrganizationsList]);

  useEffect(() => {
    setTableLoader(isLoading);
  }, [isLoading]);

  // table values
  const capitalizeFirstLetter = (str) => {
    return str?.charAt(0).toUpperCase() + str?.slice(1);
  };

  // table sorter
  const organization_nameSorter = (a, b) => {
    return a.org_name.localeCompare(b.org_name);
  };

  const ehr_nameSorter = (a, b) => {
    const ehrA = String(a.ehr_id || null);
    const ehrB = String(b.ehr_id || null);
    return ehrA.localeCompare(ehrB);
  };

  const handleEditOrganization = (org_id) => {
    storeInLocal(`${currentPractitioner?.org_uuid}_selectedOrgId`, org_id);
    dispatch(getOrganizationByIdAction(org_id, null, null));
  };

  const handleDeleteOrganization = (org_id) => {
    dispatch(getOrganizationByIdAction(org_id, setDeleteModalOpen, null));
  };

  const handlePractitioners = (record) => {
    const selectedOrg_uuid = record?.org_uuid;
    const org_name = record?.org_name;
    const org_id = record?.org_id;
    dispatch(getAllPractitionerListAction(selectedOrg_uuid));
    dispatch(getPractitionersOrgLevel(selectedOrg_uuid));
    setSelectedPractitionerOrganizationName(org_name);
    setSelectedPractitionerOrganization(selectedOrg_uuid);
    setSelectedPractitionerOrganizationId(org_id);
    setIsPractitionerHomePage(false);
    setActiveButton('Practitioners');
  };

  const menu_options = (org_id) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editCondition') {
            handleEditOrganization(org_id);
          }

          if (key === 'deleteOrganization') {
            handleDeleteOrganization(org_id);
          }
        }}
      >
        <Menu.Item key="editCondition">
          <div
            className="dropdown-text flex items-center space-x-2"
            onClick={() => navigate('/superadmin/editOrganization')}
          >
            <EditAppointmentIcon /> <span>Edit organization</span>
          </div>
        </Menu.Item>
        <Menu.Item key="deleteOrganization">
          <div className="dropdown-text flex items-center space-x-2">
            <BinIcon /> <span>Remove organization</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  // table column
  const columns = [
    {
      title: (
        <span className="font-[700]">
          {' '}
          Organization
          {filteredData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'org_name',
      key: 'org_name',
      sorter: filteredData?.length > 0 && organization_nameSorter,
      render: (text, record) => (
        <div className="flex items-center">
          <span className="mr-2">
            {record?.logo_url && (
              <img
                src={record?.logo_url}
                // alt="Organization Icon"
                className="w-10 h-10 cursor-pointer rounded-full"
              />
            )}
          </span>
          <span
            className="cursor-pointer"
            onClick={() => handlePractitioners(record)}
          >
            {text}
          </span>
        </div>
      ),
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          EHR system
          {filteredData?.length > 0 && <Sort className={'sort-icon-doctor'} />}
        </span>
      ),
      dataIndex: 'ehr_id',
      key: 'ehr_id',
      sorter: filteredData?.length > 0 && ehr_nameSorter,
    },
    {
      title: (
        <span className="font-[700]">
          {' '}
          Website
          {/* <Sort className={"sort-icon-doctor"} /> */}
        </span>
      ),
      dataIndex: 'website',
      key: 'website',
      // sorter: website_nameSorter,
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown className="" overlay={menu_options(record?.org_id)}>
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    const unsubscribe = organizationEventEmitter.subscribe(
      'organizationChanged',
      (newOrg) => {
        setSelectedOrganization(newOrg?.value);
        setSelectedOrganizationUUID(newOrg?.org_uuid);
        handleSelectChange(newOrg);
      }
    );
    return () => unsubscribe();
  }, []);

  const handleSelectChange = (e) => {
    const orgId = e === 'All' ? null : e?.value;
    setSelectedOrganization(orgId);
    setSelectedOrganizationUUID(e.org_uuid);
    setOrganizationName(e);
    if (selectedEHRSystem) {
      if (orgId === null) {
        const payload = { org_id: null, ehr_id: selectedEHRSystem };
        dispatch(filterOrganizationApiAction(payload));
        setIsFilterOn(true);
      } else {
        const payload = { org_id: e?.value, ehr_id: selectedEHRSystem };
        dispatch(filterOrganizationApiAction(payload));
        setIsFilterOn(true);
      }
    } else {
      if (orgId === null) {
        dispatch(getAllOrganizationPaginationAction(startIndex, null));
        setIsFilterOn(false);
      } else {
        dispatch(getOrganizationByIdAction(orgId, null, null));
        setIsFilterOn(true);
      }
    }
  };

  useEffect(() => {
    if (selectedEHRSystem) {
      if (selectedOrganization === null) {
        const payload = { org_uuid: null, ehr_id: selectedEHRSystem };
        dispatch(filterOrganizationApiAction(payload));
        setIsFilterOn(true);
      } else {
        const payload = {
          org_uuid: selectedOrganizationUUID,
          ehr_id: selectedEHRSystem,
        };
        dispatch(filterOrganizationApiAction(payload));
        setIsFilterOn(true);
      }
    } else {
      if (selectedOrganization === null) {
        dispatch(getAllOrganizationPaginationAction(startIndex, null));
        setIsFilterOn(false);
      } else {
        dispatch(
          getOrganizationByIdAction(selectedOrganization, null, 'pagination')
        );
        setIsFilterOn(true);
      }
    }
  }, [dispatch, selectedOrganization, selectedEHRSystem, startIndex]);

  return (
    <>
      <div>
        <Formik>
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <div>
                <div className="flex flex-col sm:flex-row lg:justify-between justify-center items-center">
                  <div className="flex flex-col sm:flex-row">
                    <div className="flex justify-start gap-12 ">
                      {/* Commenting out EHR system filter because we always show one org in the table, so filtering by EHR system is not needed
                       <div className="bg-white shadow-sm rounded-xl w-60 flex items-center">
                        <Select
                          style={{
                            placeholder: {
                              fontFamily: 'Poppins',
                              color: '#667085',
                            },
                          }}
                          bordered={false}
                          className="border-none font-sans h-10 flex items-center  focus:outline-none w-full"
                          optionFilterProp="label"
                          showSearch
                          placeholder="Select EHR system"
                          options={[
                            { label: 'All', value: 'All' },
                            ...ehrFilterOrganizationList.map((ehr) => ({
                              label: ehr,
                              value: ehr,
                            })),
                          ]}
                          id="search_ehr"
                          onChange={handleEHRSelectChange}
                        ></Select>
                      </div> */}
                    </div>
                  </div>
                  <div className="flex justify-end items-end">
                    <Button type={'button'} onClick={handleClick}>
                      <PlusIcon className={`mr-2`} /> Add organization
                    </Button>
                  </div>
                </div>
                <div>
                  <div className="mt-5 ant-table rounded-xl shadow-xl">
                    <SuperAdminTable
                      className={'appointment-page-table'}
                      data={filteredData}
                      columns={columns}
                      loading={tableLoader}
                      locale={{ emptyText: 'No Data' }}
                    />

                    <div className="flex justify-center items-center mt-4">
                      <p>
                        {!isfilterOn
                          ? `Showing ${filteredData?.length} of ${
                              filteredOrganizationTotal
                                ? filteredOrganizationTotal
                                : organizationTotal
                            } `
                          : ''}{' '}
                      </p>
                    </div>
                    {!isfilterOn && (
                      <div className="flex justify-center items-center ">
                        <Progress
                          percent={beforepercent * 100}
                          strokeColor="#00D090"
                          showInfo={false}
                          size="small"
                          style={{
                            width: '200px',
                            height: '2px',
                          }}
                        />
                      </div>
                    )}
                    <div className=" flex justify-center items-center p-4 mt-2">
                      {filteredData?.length > 0 &&
                        filteredData.length >= itemsPerPage &&
                        ((!isfilterOn && organizationTotal >= startIndex) ||
                          (isfilterOn &&
                            filteredOrganizationTotal >= startIndex)) && (
                          <button
                            onClick={handleShowMore}
                            disabled={isLoading ? true : false}
                            id="showmore_org"
                            className="show-more-button bg-[#00D090] rounded-full hover:bg-[#059669] text-white font-semibold  mb-10 p-2 py-2 px-16"
                          >
                            {isfilterOn &&
                            filteredData?.length !== startIndex &&
                            organizationTotal > startIndex ? (
                              <Bars
                                height="25"
                                width="25"
                                color="#ffffff"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=" justify-center"
                                visible={true}
                              />
                            ) : !isfilterOn && data?.length !== startIndex ? (
                              <Bars
                                height="25"
                                width="25"
                                color="#ffffff"
                                ariaLabel="bars-loading"
                                wrapperStyle={{}}
                                wrapperClass=" justify-center"
                                visible={true}
                              />
                            ) : (
                              ''
                            )}
                            {isfilterOn &&
                            filteredData?.length !== startIndex &&
                            organizationTotal > startIndex
                              ? ''
                              : !isfilterOn && data?.length !== startIndex
                                ? ''
                                : 'Show More'}
                          </button>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <DeleteOrganization
        isOpen={deleteModalOpen}
        setIsOpen={setDeleteModalOpen}
        isfilterOn={isfilterOn}
        selectedOrganization={selectedOrganization}
      />
    </>
  );
};

export default Organizationpage;
